import createSlideshow from '../modules/slideshow/create_slideshow';
import screenSizeUtil from '../services/screen_size';
import PhotoGalleryLauncher from '../modules/photo-gallery-launcher';
import config from '../config';
let $els = false;

export default function (slideIndex, backbutton) {
    if (config.get('featureFlags.mobilePhotoGallery') === true) {
        if (screenSizeUtil.getSize() === 'small') {
            $('.fc-header .slide-list').each((index, item) => {
                let $item = $(item);
                let hasAlreadyBeenInited = $item.hasClass('already-inited');
                let hasNotBeenAlreadyBeenInited = !hasAlreadyBeenInited;
                if (hasNotBeenAlreadyBeenInited) {
                    $item.addClass('already-inited');
                    let photoGalleryLauncher = new PhotoGalleryLauncher($item, slideIndex);
                    photoGalleryLauncher.init();
                }
            });
            return '';
        }
    }

    if (backbutton === true) {
        $els.slick('slickGoTo', parseInt(slideIndex, 10) - 1);
        return false;
    }

    $els = createSlideshow('.fc-header .slide-list, .fc-header .caption-list', true, slideIndex);
}
